import { Plugin } from '@nuxt/types'

export interface PageLoad {
  start(): void
  finish(): void
  startDateMs: number | null
  finishDateMs: number | null
  spaLoadTime(): string
  pageLoadTime(): string
}

const DECIMAL_PRECISION = 2

const pageLoad: Plugin = (context, inject) => {
  const pageLoadFunctions: PageLoad = {
    finish() {
      this.finishDateMs = Date.now()
    },
    finishDateMs: null,
    pageLoadTime() {
      const performanceTime =
        window.performance.timing || (window as any).msPerformance.timing
      const difInMs =
        (performanceTime.loadEventEnd - performanceTime.connectStart) / 1000
      return difInMs.toFixed(DECIMAL_PRECISION)
    },
    spaLoadTime() {
      const difInMs = (this.finishDateMs! - this.startDateMs!) / 1000
      return difInMs.toFixed(DECIMAL_PRECISION)
    },

    start() {
      this.startDateMs = Date.now()
    },
    startDateMs: null,
  }

  inject('pageLoad', pageLoadFunctions)
  // @ts-ignore
  context.$pageLoad = pageLoadFunctions
}

export default pageLoad
